/**
*  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RequestsListComponent } from './components/requestslist.component';
import { RequestsRoutingModule } from './requests-routing.module';
import { RequestslistService } from './services/requestslist.service';
import { RouterModule } from '@angular/router';
import { CustomerPreferenceService } from '../../preference/customerpreference.service';
import { RequestsComponent } from './components/requests.component';
import { InfiniteScrollModule } from '../shared/module/infinite-scroll.module';
import { SpinnerModule } from '../../../shared/spinner/spinner.module';
import { RequestDetailComponent } from './components/requestdetail.component';
import { RequestDetailService } from './services/request-detail.service';
import { LinkifyPipe } from '../shared/pipes/linkify.pipe';
import { TinymceModule } from '../../../shared/tinymce/tinymce.module';
import { FileUploadModule } from '../../../shared/fileupload/fileupload.module';
import { RequestsService } from './services/requests.service';
import { RequestsFilterComponent } from './components/requestsfilter.component';
import { SharedModule } from '../../../shared/shared.module';
import { SelfHelpModule } from '../selfhelp/selfhelp.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RequestsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    SpinnerModule,
    TinymceModule,
    FileUploadModule,
    SharedModule,
    SelfHelpModule
  ],
  declarations: [ RequestsComponent, RequestsListComponent, RequestsFilterComponent,
     RequestDetailComponent, LinkifyPipe ],
  providers: [ RequestsService, RequestslistService , CustomerPreferenceService, RequestDetailService ],
    exports: [ RequestsComponent, RequestsListComponent, CommonModule , RouterModule]
})
export class RequestsModule { }
